import React, { useState } from "react";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import Container from 'react-bootstrap/Container';
import { useNavigate } from 'react-router-dom';
import './login.css'

function LoginForm() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email || !password) {
      setError('Please fill in all fields.');
      return;
    }

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username: email, password: password })
    };

    fetch(apiUrl + "login", requestOptions)
      .then(res => {
        if (res.status === 200) { 
          res.json().then(
            (success) => {
              localStorage.setItem('token', success.token)
              navigate('/')
            }
          )
        }

        return res.json()
      })
      .then(
        (result) => {
          setError(result.message)
        },
        (error) => {
          setError('Something went wrong. Try again later')
        }
      )
  };

  return (
    <div className="login-page">
      <Container className="login-container">
        <div className="login-card">
          <h2 className="login-title text-center mb-4">Website Builder Login</h2>
          {error && <Alert variant="danger" className="login-alert">{error}</Alert>}
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3 form-row-horizontal" controlId="formBasicEmail">
              <Form.Label column={'sm'}>Email address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3 form-row-horizontal" controlId="formBasicPassword">
              <Form.Label column={'sm'}>Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Group>

            <div className="login-actions">
              <Button variant="primary" type="submit" className="login-button">
                Login
              </Button>
            </div>
          </Form>
        </div>
      </Container>
    </div>
  );
}

export default LoginForm;